import { DownloadIcon, EditIcon, Trash2Icon } from 'lucide-react'

import {
  ActionsMenu,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui'
import {
  DeleteDocumentsDialog,
  type Document,
  EditDocumentDialog,
} from '@/modules/documents'
import { useDialogActions } from '@/stores/dialog'

interface HeaderActionsProps {
  document: Document
}

export default function HeaderActions({ document }: HeaderActionsProps) {
  const { openDialog } = useDialogActions()

  return (
    <div className="flex items-center gap-2">
      <DeleteDocumentsDialog />
      <EditDocumentDialog />
      <ActionsMenu>
        <DropdownMenuItem
          onClick={() => openDialog(EditDocumentDialog.id, document)}
        >
          <EditIcon className="h-4 w-4" />
          Change folder
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a
            href={document.fileUrl}
            className="block truncate text-sm"
            rel="noopener noreferrer"
            target="_blank"
          >
            <DownloadIcon className="h-4 w-4" />
            Download original file
          </a>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => openDialog(DeleteDocumentsDialog.id, [document])}
          destructive
        >
          <Trash2Icon className="h-4 w-4" />
          Delete document
        </DropdownMenuItem>
      </ActionsMenu>
    </div>
  )
}
